<script setup lang="ts">
import notFound from '@/assets/not-found.svg'
import { Button } from '@/components/ui/button'

import { Link } from '@inertiajs/vue3'

defineProps<{ route: string }>()
</script>

<template>
    <div class="grid gap-6 md:grid-cols-2">
        <div class="flex flex-col items-center justify-center">
            <h3 class="text-center font-sans text-lg font-medium text-gray-800">
                {{ $t('There are no participants linked to this ticket yet.') }}
            </h3>
            <p class="mt-2 text-center text-sm text-gray-600">
                {{ $t('Link a participant to this ticket by clicking below.') }}
            </p>

            <Button class="mt-6 px-12" :as="Link" :href="route">{{ $t('Assign participant') }}</Button>
        </div>
        <div class="">
            <img :src="notFound" alt="" />
        </div>
    </div>
</template>
